import { render, staticRenderFns } from "./Bauamt.vue?vue&type=template&id=5aeebf88&scoped=true"
import script from "./Bauamt.vue?vue&type=script&lang=js"
export * from "./Bauamt.vue?vue&type=script&lang=js"
import style0 from "./Bauamt.vue?vue&type=style&index=0&id=5aeebf88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aeebf88",
  null
  
)

export default component.exports